// these custom hook is used to verify that user is admin or not
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { checkIfUserIsAdmin } from "../auth/checkAdmin";

const useAdminStatus = () => {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    const fetchAdminStatus = async () => {
      try {
        const adminStatus = await checkIfUserIsAdmin();
        setIsAdmin(adminStatus);
      } catch (error) {
        toast.error(error.message);
      }
    };

    fetchAdminStatus();
  }, []);

  return isAdmin;
};

export default useAdminStatus;
